import { PAYMENT_HOLD_MINUTES, PAYMENT_HOLD_SEC, getPaymentExpiresAt } from "../lib/paymentHold"
import { usePaymentHoldTimer } from "../hooks/usePaymentHoldTimer"

const BODY = "'Manrope', sans-serif"
const MONO = "'JetBrains Mono', monospace"

type Props = {
    createdAt?: string | null
    expiredAt?: string | null
    className?: string
    compact?: boolean
}

export default function PaymentHoldBanner({ createdAt, expiredAt, className = "", compact = false }: Props) {
    const deadline = getPaymentExpiresAt(createdAt, expiredAt)
    const { remainSec, formatted, isParsed } = usePaymentHoldTimer(createdAt, expiredAt)
    const expired = isParsed && remainSec === null && formatted === null
    const progress = remainSec != null ? remainSec / PAYMENT_HOLD_SEC : 0
    const ringDeg = `${Math.max(0, Math.min(1, progress)) * 360}deg`

    if (!deadline) return null

    if (expired) {
        return (
            <div
                className={`flex gap-3 rounded-[14px] border px-4 py-3 ${className}`}
                style={{ borderColor: "rgba(228,32,107,0.35)", background: "rgba(228,32,107,0.08)" }}>
                <span className="shrink-0 text-[18px]">⌛</span>
                <div>
                    <p className="text-[#e4206b] text-[13px] font-semibold" style={{ fontFamily: MONO }}>
                        Время бронирования истекло
                    </p>
                    <p className="mt-0.5 text-white/45 text-[12px] leading-relaxed" style={{ fontFamily: BODY }}>
                        Места освобождены. Оформите заказ заново.
                    </p>
                </div>
            </div>
        )
    }

    if (!formatted) return null

    return (
        <div
            className={`flex items-center gap-3 rounded-[14px] border px-4 py-3 ${className}`}
            style={{ borderColor: "rgba(245,166,35,0.35)", background: "rgba(245,166,35,0.08)" }}>
            <div
                className="relative flex size-12 shrink-0 items-center justify-center rounded-full"
                style={{
                    background: `conic-gradient(#f5a623 ${ringDeg}, rgba(255,255,255,0.08) 0)`,
                }}>
                <div
                    className="flex size-10 items-center justify-center rounded-full"
                    style={{ background: "rgba(10,18,42,0.92)" }}>
                    <span className="text-[#f5a623] text-[13px] tabular-nums" style={{ fontFamily: MONO, fontWeight: 800 }}>
                        {formatted}
                    </span>
                </div>
            </div>
            <div className="min-w-0">
                <p className="text-[#f5a623] text-[13px] font-semibold" style={{ fontFamily: MONO }}>
                    {compact ? "Осталось время" : "На оплату осталось"}
                </p>
                <p className="mt-0.5 text-white/45 text-[12px] leading-relaxed" style={{ fontFamily: BODY }}>
                    Места зарезервированы на {PAYMENT_HOLD_MINUTES} минут с момента создания заказа
                </p>
            </div>
        </div>
    )
}
